import { useState } from "react";
import Skeleton from "./Skeleton";

const LazyImage = ({ src, alt, className }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    return (
        <div className={`tw-relative ${className}`}>
            {isLoading && <Skeleton className={className} />}
            <img
                src={src}
                alt={alt}
                className={`${className} ${isLoading ? "tw-hidden" : ""}`}
                onLoad={() => setIsLoading(false)}
                onError={() => {
                    setIsLoading(false);
                    setError(true);
                }}
            />
            {error && (
                <div className={`${className} tw-bg-gray-100 tw-flex tw-items-center tw-justify-center`}>
                    <span className="tw-text-gray-400">Failed to load image</span>
                </div>
            )}
        </div>
    );
};

export default LazyImage;
